import {
  Component, Input, OnInit, forwardRef,
  ElementRef, ViewChild, AfterContentChecked, OnChanges, SimpleChanges
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Countries } from '../../translations/countries-translations/country.service';
import parsePhoneNumber from 'libphonenumber-js';

export const mobileStringLength = 8;

@Component({
  selector: 'bc-phone-input',
  templateUrl: './bc.phone-input.component.html',
  styleUrls: ['./bc.phone-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BcPhoneInputComponent),
      multi: true
    }
  ]
})
export class BcPhoneInputComponent implements OnInit, ControlValueAccessor, AfterContentChecked, OnChanges {
  @ViewChild('phoneInput', { static: true }) phoneInput: ElementRef;
  @Input() defaultCountry = 'nl';
  @Input() focus: boolean;
  @Input() value: string;
  @Input() disabled: boolean;

  countries: Array<any>;
  flag: string;
  toggle: boolean;

  private onModelChange: any;

  constructor(private countriesService: Countries) {
  }

  ngOnInit() {
    this.countries = this.countriesService.getUnprioritized();

    this.flag = this.defaultCountry;
    this.phoneInput.nativeElement.value = `+${this.getCountryCode(this.defaultCountry)}`;

    if (this.value !== undefined) {
      this.phoneInput.nativeElement.value = this.value;
    }
  }

  ngAfterContentChecked() {
    if (this.focus) {
      this.phoneInput.nativeElement.focus();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value !== undefined) {
      this.phoneInput.nativeElement.value = changes.value.currentValue;
    }
  }

  writeValue(value: any): void {
    const phoneNumber = value || `+${this.getCountryCode(this.defaultCountry)}`;
    this.phoneInput.nativeElement.value = phoneNumber;
    this.setFlag(phoneNumber);
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched() {  }

  selectCountry(country: any) {
    this.flag = country.value.toLowerCase();
    this.phoneInput.nativeElement.value = `+${country.code}`;
  }

  keyUp(event: any) {
    event.target.value = event.target.value.replace(/^00/, '+');
    this.onModelChange(event.target.value);

    this.setFlag(event.target.value);
  }

  onChange(event: any) {
    try {
      if (String(event.target.value).length >= mobileStringLength) {
        const phoneNumber = parsePhoneNumber(event.target.value);
        phoneNumber.format('E.164');
        this.phoneInput.nativeElement.value = phoneNumber.number;
      }

      this.onModelChange(event.target.value);
      this.setFlag(event.target.value);
    } catch (e) {
    }
  }

  private setFlag(value: string) {
    if (String(value).length >= mobileStringLength) {
      try {
        const phoneNumber = parsePhoneNumber(value);
        this.flag = phoneNumber.country.toLowerCase();

      } catch (e) {
      }
    }
  }

  private getCountryCode(countryCode: string) {
    const selectedCountry = this.countriesService.get().find((country: any) => country.value.toLowerCase() === countryCode);

    return selectedCountry ? selectedCountry.code: '';
  }
}
